/**
 * categorie.js — elenchi codificati usati nei menu a tendina.
 *
 * Sono costanti di installazione: dato che ogni cliente ha la propria
 * installazione dedicata, questo file si adatta al singolo studio senza
 * toccare il resto del codice. Se in futuro servisse la gestione da
 * interfaccia, gli stessi valori diventano una tabella `categorie`.
 */

/** Tipo di prestazione erogata (catalogo prestazioni) */
export const CATEGORIE_PRESTAZIONE = [
    'Visita',
    'Consulenza',
    'Iniezioni',
    'Tossina botulinica',
    'Filler',
    'Biostimolazione',
    'Mesoterapia',
    'Fili di trazione',
    'Peeling',
    'Laser',
    'Luce pulsata',
    'Radiofrequenza',
    'Ultrasuoni focalizzati',
    'Criolipolisi',
    'Chirurgia ambulatoriale',
    'Medicazione',
    'Diagnostica',
    'Tricologia',
    'Prodotti e cosmetici',
    'Altro'
];

/** Area medica di riferimento (modelli di consenso) */
export const SPECIALITA_MEDICHE = [
    'Medicina estetica',
    'Dermatologia',
    'Chirurgia plastica',
    'Chirurgia generale',
    'Angiologia',
    'Ortopedia',
    'Ginecologia',
    'Endocrinologia',
    'Nutrizione',
    'Tricologia',
    'Fisioterapia',
    'Odontoiatria',
    'Psicologia',
    'Medicina generale',
    'Altro'
];

/** Sigle delle province italiane (107) + EE per nascita all'estero */
export const PROVINCE_ITALIANE = [
    'AG', 'AL', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AT', 'AV', 'BA', 'BG', 'BI',
    'BL', 'BN', 'BO', 'BR', 'BS', 'BT', 'BZ', 'CA', 'CB', 'CE', 'CH', 'CL',
    'CN', 'CO', 'CR', 'CS', 'CT', 'CZ', 'EN', 'FC', 'FE', 'FG', 'FI', 'FM',
    'FR', 'GE', 'GO', 'GR', 'IM', 'IS', 'KR', 'LC', 'LE', 'LI', 'LO', 'LT',
    'LU', 'MB', 'MC', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NA', 'NO', 'NU',
    'OR', 'PA', 'PC', 'PD', 'PE', 'PG', 'PI', 'PN', 'PO', 'PR', 'PT', 'PU',
    'PV', 'PZ', 'RA', 'RC', 'RE', 'RG', 'RI', 'RM', 'RN', 'RO', 'SA', 'SI',
    'SO', 'SP', 'SR', 'SS', 'SU', 'SV', 'TA', 'TE', 'TN', 'TO', 'TP', 'TR',
    'TS', 'TV', 'UD', 'VA', 'VB', 'VC', 'VE', 'VI', 'VR', 'VT', 'VV',
    'EE'
];
